import { Controller } from "@hotwired/stimulus"

// Toggles between OTP PIN-pad mode and backup code text input mode.
// GitHub uses the same pattern: "Use a recovery code" link switches the view.
// IMPORTANT: Both modes have inputs with name="otp_code". We must disable
// the inactive mode's input to prevent it from being submitted (the last
// same-name input in DOM order wins, which would send an empty string).
export default class extends Controller {
  static targets = ["otpMode", "backupMode", "otpHidden", "backupInput"]

  showBackup(event) {
    event.preventDefault()
    this.otpModeTarget.classList.add("d-none")
    this.backupModeTarget.classList.remove("d-none")
    // Disable hidden OTP field, enable backup input
    this.otpHiddenTarget.disabled = true
    this.backupInputTarget.disabled = false
    this.backupInputTarget.focus()
    this.otpHiddenTarget.value = ""
  }

  showOtp(event) {
    event.preventDefault()
    this.backupModeTarget.classList.add("d-none")
    this.otpModeTarget.classList.remove("d-none")
    // Enable hidden OTP field, disable backup input
    this.otpHiddenTarget.disabled = false
    this.backupInputTarget.disabled = true
    this.backupInputTarget.value = ""
    const firstDigit = this.otpModeTarget.querySelector("[data-otp-input-target='digit']")
    if (firstDigit) firstDigit.focus()
  }
}
